'use strict';

var TextMessage = (function() {
    var $proportyId = null;
    var $leadId = null;
    var $input = null;
    var $send = null;
    var $headNotification = null;
    var timer = null;
    var container = null;
    var lastSent = null;
    var previousHeight = null;
    var phoneNumber = null;
    var methods = [ 'GetSmsMsgsByFilters/', 'SendSmsMsg/', 'OptInState/', 'SendOptInMessage/' ];
    var classes = [ 'to', 'from' ];
    var INITIAL_STATE = null;
    var messages = [];
    var cycles = 0;
    var optNotify = null;

    var localData = {
        action: null,
        method: null,
        contents: null,
        startDate: null,
        endDate: null
    };
    var launch = function(id, selector) {
        $leadId = id;
        container = selector;
        $input = document.getElementById('message-content');
        $send = document.getElementById('send-sms');
        getOptInState();
    };

    var getOptInState = function() {
        var settings = {
            method: 'get',
            action: methods[2]
        };

        OptInOut(settings, function(state) {
            INITIAL_STATE = state;
            if(state == lead2lease.enums.sms.states.initial ||
                state == lead2lease.enums.sms.states.default) {
                disableTexting();
                return false;
            }
            else if(state == lead2lease.enums.sms.states.preoptin) {
                disableTexting('Awaiting opt-in', true);
            }
            else if(state == lead2lease.enums.sms.states.optinwaiting) {
                recieveMessages();
                disableTexting('Opt-in request sent, waiting for prospect\'s consent');
            }
            else if(state == lead2lease.enums.sms.states.optin) {
                recieveMessages();
                bindEvents();
            }
            else if(state == lead2lease.enums.sms.states.optout) {
                disableTexting(null, null, true);
                recieveMessages();
                showNotification('Prospect previously opted out', 'fail');
            }
            else {
                disableTexting();
            }
        }, function(failed) {
            console.log(failed);
            container.scrollTop = container.scrollHeight;
            showNotification(failed, 'fail');
            return false;
        });
        // TODO: Do Opt in logic here...
        //Return value true if client chooses to opt in for text messages..
        //Text Defaulted to opt in per Dekel 12/1/2016
    };

    var requestOptIn = function() {
        var settings = {
            method: 'post',
            action: methods[3]
        };

        OptInOut(settings, function(response) {
            disableTexting('Opt-in request sent, waiting for prospect\'s consent');
            recieveMessages();
        }, function(failed) {
            container.scrollTop = container.scrollHeight;
            showNotification(failed, 'fail');
            return false;
        });
    };

    var disableTexting = function(msg, status, clear) {
        var optNotify = document.querySelector('.msg-notification-opt');
        $send.innerHTML = 'Request Opt In';
        if(msg) {
            optNotify.innerHTML = msg;
            optNotify.classList.add('show');
        }
        if(clear) {
            optNotify.innerHTML = '';
        }
        if(status) {
            toggleEvents(true);
            $input.classList.add('disabled');
            $input.setAttribute('readonly', true);
            $send.onclick = requestOptIn;
        }
        else {
            optNotify.classList.add('show');
            toggleEvents();
        }
    };

    var bindEvents = function() {
        $send.onclick = validate;
        $input.onkeyup = function(e) {
            if(e.keyCode == 13) {
                validate();
            }
        };
    };
    var validate = function() {
        if($input.value !== '' && $input.maxLength < 800) {
            send($input.value);
            $input.value = '';
        }
    };
    var send = function(msg) {
        lastSent = {
            DateLog: Date.now(),
            MessageText: msg,
            IsOutbound: true
        };

        messages.push(lastSent);

        showNotification('Sending Message', 'success');

        localData.action = methods[1];
        localData.method = 'post';
        localData.contents = msg;

        clearTimeout(timer);

        transaction(localData, function(res) {
            //replace temporary sent with server response sent

            messages[messages.indexOf(lastSent)] = res;
            localData.startDate = Date.now();
            createComponents([ res ]);
            container.scrollTop = container.scrollHeight;
            showNotification('Message Sent', 'success');

            timer = setTimeout(recieveMessages, 3000);
        }, function(failed) {
            container.scrollTop = container.scrollHeight;
            showNotification(failed, 'fail');
        });
    };
    var recieveMessages = function() {
        localData.action = methods[0];
        localData.method = 'get';
        localData.contents = null;
        transaction(localData, function(res) {
            for(var i = res.Data.length - 1; i >= 0; i--) {
                var obj = res.Data[i];

                if(!hasId(messages, obj)) {
                    messages.push(obj);
                    createComponents([ obj ]);
                    if(cycles < 1) {
                        container.scrollTop = container.scrollHeight;
                    }
                    if(cycles > 1) {
                        container.scrollTop = container.scrollHeight;
                        showNotification('New Message Received', 'success');
                    }
                }
            }

            cycles = cycles + 1;

            if(res.State == lead2lease.enums.sms.states.optout) {
                INITIAL_STATE = res.State;
                disableTexting(null, null, true);
                showNotification('Prospect previously opted out', 'fail');
                $send.innerHTML = 'SEND';
            }

            if(res.State == lead2lease.enums.sms.states.optinwaiting) {
                INITIAL_STATE = res.State;
                disableTexting('Opt-in request sent, waiting for prospect\'s consent');
            }

            if(res.State == lead2lease.enums.sms.states.optin && res.State != INITIAL_STATE) {
                INITIAL_STATE = res.State;
                $send.innerHTML = 'SEND';
                toggleEvents(true);
                bindEvents();
            }

            timer = setTimeout(recieveMessages, 3000);
        });
    };
    var hasId = function(list, obj) {
        for(var i in list) {
            if(list[i].Id === obj.Id) {
                return true;
            }
        }

        return false;
    };
    var showNotification = function(msg, type) {
        var optNotify = document.querySelector('.msg-notification-opt');
        var note = document.getElementById('notify');
        note.innerHTML = msg;

        if(type == 'fail') {
            note.className = 'msg-notification danger text-white';
            note.classList.add('show');
            optNotify.classList.remove('show');
        }
        else if(type == 'success') {
            note.className = 'msg-notification primary text-white';
            note.classList.add('show');
            optNotify.classList.remove('show');
        }
        else {
            note.classList.add('show');
            optNotify.classList.remove('show');
        }

        note.onclick = function() {
            container.scrollTop = container.scrollHeight;
            note.classList.remove('show');
        };

        container.onclick = function() {
            note.classList.remove('show');
        };

        container.onscroll = function() {
            note.classList.remove('show');
            note.classList.remove('danger', 'color', 'white');
        };
    };
    var createComponents = function(components) {
        components.forEach(function(item) {
            // Build components here
            var $date = lead2lease.utilities.date.getDateTime(item.DateLog)
                .format('MM-DD-YYYY hh:mm A');

            if(item.IsOutbound) {
                listComponent(classes[0], item.MessageText, $date, '<i class="fa fa-user" aria-hidden="true"></i>');
            }
            else {
                listComponent(classes[1], item.MessageText, $date, '<span class="rp-icon-user-profile font-12"></span>');
            }
        });
    };
    var listComponent = function(type, msg, date, icon) {
        var listItem = document.createElement('li');
        listItem.className = 'msg-list-item ' + type;

        var elContent = document.createElement('div');
        elContent.className = 'msg-content';
        elContent.innerHTML = msg;

        var elAvatar = document.createElement('div');
        elAvatar.className = 'msg-avatar';
        elAvatar.innerHTML = icon;
        var elDate = document.createElement('div');
        elDate.className = 'msg-date';
        elDate.innerHTML = date;

        listItem.appendChild(elAvatar);
        listItem.appendChild(elContent);
        listItem.appendChild(elDate);
        pushToView(listItem);
    };
    var pushToView = function(listItem) {
        container.appendChild(listItem);
    };
    var transaction = function(data, callback, errorCallback) {
        var requestData = {
            id: lead2lease.session.activePropertyId,
            userId: null,
            leadId: $leadId
        };

        if(data.method === 'post') {
            requestData.destinationNumber = null;
            requestData.messageText = data.contents;
        }
        else {
            requestData.maxReturns = 100;
            requestData.status = null;
            requestData.messageSid = null;
            requestData.destination = null;
            requestData.source = null;
            requestData.startDate = data.startDate;
            requestData.endDate = data.endDate;
        }

        lead2lease.network.request('api', data.method, 'v1/SmsMsgs/' + data.action, requestData, null, function(error, data) {
            if(error != null) {
                errorCallback('Message Failed To Send');
            }
            else {
                callback(JSON.parse(data.responseText));
            }
        });
    };

    var OptInOut = function(data, callback, errorCallback) {
        var params = {
            id: lead2lease.session.activePropertyId,
            leadId: $leadId
        };
        lead2lease.network.request('api', data.method, 'v1/SmsMsgs/' + data.action, params, null, function(error, data) {
            if(error != null) {
                toggleEvents();
                errorCallback('Failed Opt-In');
            }
            else {
                callback(JSON.parse(data.responseText));
            }
        });
    };

    var toggleEvents = function(bool) {
        if(bool) {
            $send.classList.remove('disabled');
            $send.removeAttribute('readonly');
            $input.classList.remove('disabled');
            $input.removeAttribute('readonly');
        }
        else {
            $send.classList.add('disabled');
            $send.setAttribute('readonly', true);
            $send.onclick = null;
            $input.classList.add('disabled');
            $input.setAttribute('readonly', true);
        }
    };

    return {
        launch: launch,
        lastSent: lastSent,
        showNotification: showNotification
    };
})();
